export const MOCK_CONTRACT_DETAILS = {
  entity: {
    contract_name: 'Dynamic Green+',
    contract_number: '589010218',
    account_number: '',
    move_in_date: '2025-05-01',
    type: 'recurring',
    installment_amount: 20000,
    installment_amount_currency: 'EUR',
    installment_amount_decimal: '200.00',
    balance: 0,
    balance_currency: 'EUR',
    balance_decimal: '0.00',
    power: 'gas',
    _schema: 'contract',
    _id: '78d3639c-ef63-4517-9942-3407dda87de7',
    _org: 'test-org',
    _created_at: '2025-05-07T07:58:32.296Z',
    _updated_at: '2025-06-17T11:03:27.608Z',
    status: 'active',
    billing_period: 'monthly',
    billing_duration_unit: 'months',
    notice_time_unit: 'months',
    termination_time_unit: 'months',
    renewal_duration_unit: 'months',
    _title: 'Dynamic Green+',
    meters: {
      $relation: [
        {
          entity_id: '3c95352d-32e2-486d-9991-d565f3b84e11',
          _tags: []
        }
      ]
    },
    customer: {
      $relation: [
        {
          entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
          _schema: 'contact',
          _tags: []
        }
      ]
    },
    line_items: [
      {
        price_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
        product_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
        quantity: 1,
        description: 'Dynamic Green+',
        unit_amount: 0,
        unit_amount_decimal: '0.00',
        pricing_model: 'per_unit',
        item_components: [
          {
            price_id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
            product_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
            quantity: 1,
            description: 'Grundpreis',
            unit_amount: 0,
            unit_amount_decimal: '1.3e-9',
            pricing_model: 'tiered_volume',
            _price: {
              _id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
              _manifest: [
                '3babbfe8-80a2-4e19-b9e6-3d6d4fa22730',
                '50fb9921-3b0d-430a-9211-5b741e601008',
                '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                '4573c148-9fa1-4de8-bb05-964a01690789'
              ],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom'],
              active: true,
              description: 'Grundpreis',
              is_tax_inclusive: true,
              price_display_in_journeys: 'show_price',
              pricing_model: 'tiered_volume',
              tax: [
                {
                  _manifest: [
                    '956e9f44-0d8e-4d50-af85-e528fb130d64',
                    'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                    '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                    '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                    '4573c148-9fa1-4de8-bb05-964a01690789'
                  ],
                  _schema: 'tax',
                  active: true,
                  description: '19%',
                  rate: '19',
                  region: 'DE',
                  type: 'VAT',
                  _id: '170d696a-611a-4627-a904-137741027989',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:09:29.464Z',
                  _updated_at: '2025-04-04T07:57:19.848Z',
                  _title: '19%',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  }
                }
              ],
              tiers: [],
              type: 'recurring',
              unit_amount: 1300,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '13',
              variable_price: true,
              billing_duration_amount: '',
              billing_duration_unit: null,
              billing_period: 'monthly',
              internal_description: 'Grundpreis',
              notice_time_amount: null,
              notice_time_unit: null,
              price_components: null,
              renewal_duration_amount: null,
              renewal_duration_unit: null,
              termination_time_amount: null,
              termination_time_unit: null,
              _title: 'Grundpreis',
              averageMarketPrice: {
                market: 'day_ahead',
                bidding_zone: 'DE-LU',
                price: {
                  timestamp:
                    '2025-04-01T00:00:00.000+02:00/2025-04-30T23:59:59.999+02:00',
                  unit_amount: 7.79,
                  unit_amount_decimal: '0.0779',
                  unit_amount_currency: 'EUR'
                },
                _meta: {
                  timestamp: 1747981644144,
                  signature:
                    'f391184cf47d00e988962261f36b7b47dc8169298ec11a04c52c0bb16af49c48'
                },
                inputs: {
                  market: 'day_ahead',
                  bidding_zone: 'DE-LU',
                  from: '2025-04-01',
                  to: '2025-04-30'
                }
              }
            },
            _product: {
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom', 'dont-touch'],
              active: true,
              categories: [],
              description: 'Außerhalb der Grundversorgung',
              feature: [
                {
                  _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                  _tags: [],
                  feature: '100% Ökostrom',
                  value: ''
                },
                {
                  _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                  _tags: [],
                  feature: 'Erstlaufzeit bis 31.12.2025',
                  value: ''
                },
                {
                  _id: 'SbRtgtY6flxvlR1M-LaHi',
                  _tags: [],
                  feature: 'Kündigungsfrist 1 Monat',
                  value: ''
                },
                {
                  _id: 'v07rw_RfinlcUOfQD0h9S',
                  _tags: [],
                  feature:
                    '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                  value: ''
                }
              ],
              internal_name: 'Strom Green+',
              name: 'Strom Green+',
              price_options: [
                {
                  _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                  _schema: 'price',
                  _tags: ['Commodity', 'Strom'],
                  active: true,
                  description: 'Classic Green+',
                  is_composite_price: true,
                  is_tax_inclusive: null,
                  price_components: [],
                  price_display_in_journeys: 'show_price',
                  pricing_model: null,
                  tiers: [],
                  type: null,
                  unit_amount: 0,
                  unit_amount_currency: 'EUR',
                  unit_amount_decimal: '0.00',
                  variable_price: null,
                  billing_duration_amount: null,
                  billing_duration_unit: null,
                  billing_period: null,
                  internal_description: 'Classic Green+',
                  notice_time_amount: null,
                  notice_time_unit: null,
                  renewal_duration_amount: null,
                  renewal_duration_unit: null,
                  termination_time_amount: null,
                  termination_time_unit: null,
                  unit: null,
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:27.709Z',
                  _updated_at: '2025-05-23T06:23:55.130Z',
                  _title: 'Classic Green+',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  $relation: {
                    entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
                  }
                },
                {
                  _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                  _schema: 'price',
                  _tags: ['Commodity', 'Strom'],
                  active: true,
                  billing_duration_unit: 'months',
                  description: 'Dynamic Green+',
                  is_composite_price: true,
                  is_tax_inclusive: true,
                  notice_time_unit: 'months',
                  price_components: [],
                  price_display_in_journeys: 'show_price',
                  pricing_model: 'per_unit',
                  renewal_duration_unit: 'months',
                  termination_time_unit: 'months',
                  tiers: [],
                  type: 'one_time',
                  unit_amount: 0,
                  unit_amount_currency: 'EUR',
                  unit_amount_decimal: '0.00',
                  variable_price: false,
                  billing_period: 'weekly',
                  internal_description: 'Dynamic Green+',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:27.918Z',
                  _updated_at: '2025-05-23T06:24:15.056Z',
                  _title: 'Dynamic Green+',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  $relation: {
                    entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac'
                  }
                }
              ],
              product_downloads: [
                {
                  _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Datenschutz'],
                  _title: 'Datenschutzinformationen.pdf',
                  access_control: 'public-read',
                  filename: 'Datenschutzinformationen.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'Datenschutz'],
                      _title: 'Datenschutzinformationen.pdf',
                      access_control: 'public-read',
                      filename: 'Datenschutzinformationen.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:20.522Z',
                  _updated_at: '2025-04-04T07:57:21.022Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                  $relation: {
                    entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                  }
                },
                {
                  _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'AGB'],
                  _title: 'AGB.pdf',
                  access_control: 'public-read',
                  filename: 'AGB.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'AGB'],
                      _title: 'AGB.pdf',
                      access_control: 'public-read',
                      filename: 'AGB.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:21.247Z',
                  _updated_at: '2025-04-04T07:57:21.704Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                  $relation: {
                    entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                  }
                },
                {
                  _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Widerrufsformular'],
                  _title: 'Muster-Widerrufsformular.pdf',
                  access_control: 'public-read',
                  filename: 'Muster-Widerrufsformular.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'Widerrufsformular'],
                      _title: 'Muster-Widerrufsformular.pdf',
                      access_control: 'public-read',
                      filename: 'Muster-Widerrufsformular.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:21.101Z',
                  _updated_at: '2025-04-04T07:57:21.569Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                  $relation: {
                    entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                  }
                },
                {
                  _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Preisblatt'],
                  _title: 'Preisblatt.pdf',
                  access_control: 'public-read',
                  filename: 'Preisblatt.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'Preisblatt'],
                      _title: 'Preisblatt.pdf',
                      access_control: 'public-read',
                      filename: 'Preisblatt.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:20.386Z',
                  _updated_at: '2025-04-04T07:57:20.823Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                  $relation: {
                    entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                  }
                }
              ],
              product_images: [],
              type: 'product',
              _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
              _title: 'Strom Green+',
              _messages: {}
            },
            taxes: [
              {
                tax: {
                  _manifest: [
                    '956e9f44-0d8e-4d50-af85-e528fb130d64',
                    'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                    '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                    '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                    '4573c148-9fa1-4de8-bb05-964a01690789'
                  ],
                  _schema: 'tax',
                  active: true,
                  description: '19%',
                  rate: '19',
                  region: 'DE',
                  type: 'VAT',
                  _id: '170d696a-611a-4627-a904-137741027989',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:09:29.464Z',
                  _updated_at: '2025-04-04T07:57:19.848Z',
                  _title: '19%',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  }
                },
                amount: 0
              }
            ],
            type: 'recurring',
            billing_period: 'monthly',
            tiers_details: [
              {
                quantity: 0,
                unit_amount: 0,
                unit_amount_decimal: '0',
                unit_amount_net: 0,
                unit_amount_gross: 0,
                amount_subtotal: 0,
                amount_total: 0,
                amount_tax: 0
              }
            ],
            unit_amount_gross: 0,
            unit_amount_net: 0,
            amount_subtotal: 0,
            amount_total: 0,
            amount_tax: 0,
            currency: 'EUR',
            is_tax_inclusive: true,
            unit_amount_net_decimal: '0',
            unit_amount_gross_decimal: '0',
            amount_subtotal_decimal: '0',
            amount_total_decimal: '0'
          },
          {
            price_id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
            product_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
            quantity: 1,
            description: 'Energie Spotmarktpreis',
            unit_amount: 24,
            unit_amount_decimal: '0.243801',
            pricing_model: 'dynamic_tariff',
            _price: {
              _id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom'],
              active: true,
              billing_duration_unit: 'months',
              description: 'Energie Spotmarktpreis',
              is_tax_inclusive: true,
              notice_time_unit: 'months',
              price_display_in_journeys: 'show_price',
              pricing_model: 'dynamic_tariff',
              renewal_duration_unit: 'months',
              tax: [
                {
                  _manifest: [
                    '956e9f44-0d8e-4d50-af85-e528fb130d64',
                    'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                    '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                    '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                    '4573c148-9fa1-4de8-bb05-964a01690789'
                  ],
                  _schema: 'tax',
                  active: true,
                  description: '19%',
                  rate: '19',
                  region: 'DE',
                  type: 'VAT',
                  _id: '170d696a-611a-4627-a904-137741027989',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:09:29.464Z',
                  _updated_at: '2025-04-04T07:57:19.848Z',
                  _title: '19%',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  }
                }
              ],
              termination_time_unit: 'months',
              tiers: [],
              type: 'recurring',
              unit: 'kwh',
              unit_amount: 0,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '0.00',
              variable_price: true,
              billing_period: 'monthly',
              dynamic_tariff: {
                interval: 'hourly',
                markup: 0,
                markup_amount: 15,
                markup_amount_decimal: '0.1511',
                markup_decimal: '0.00',
                mode: 'day_ahead_market'
              },
              internal_description: 'Energie Spotmarktpreis',
              _title: 'Energie Spotmarktpreis',
              averageMarketPrice: {
                market: 'day_ahead',
                bidding_zone: 'DE-LU',
                price: {
                  timestamp:
                    '2025-04-01T00:00:00.000+02:00/2025-04-30T23:59:59.999+02:00',
                  unit_amount: 7.79,
                  unit_amount_decimal: '0.0779',
                  unit_amount_currency: 'EUR'
                },
                _meta: {
                  timestamp: 1747981644144,
                  signature:
                    'f391184cf47d00e988962261f36b7b47dc8169298ec11a04c52c0bb16af49c48'
                },
                inputs: {
                  market: 'day_ahead',
                  bidding_zone: 'DE-LU',
                  from: '2025-04-01',
                  to: '2025-04-30'
                }
              }
            },
            _product: {
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom', 'dont-touch'],
              active: true,
              categories: [],
              description: 'Außerhalb der Grundversorgung',
              feature: [
                {
                  _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                  _tags: [],
                  feature: '100% Ökostrom',
                  value: ''
                },
                {
                  _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                  _tags: [],
                  feature: 'Erstlaufzeit bis 31.12.2025',
                  value: ''
                },
                {
                  _id: 'SbRtgtY6flxvlR1M-LaHi',
                  _tags: [],
                  feature: 'Kündigungsfrist 1 Monat',
                  value: ''
                },
                {
                  _id: 'v07rw_RfinlcUOfQD0h9S',
                  _tags: [],
                  feature:
                    '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                  value: ''
                }
              ],
              internal_name: 'Strom Green+',
              name: 'Strom Green+',
              price_options: [
                {
                  _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                  _schema: 'price',
                  _tags: ['Commodity', 'Strom'],
                  active: true,
                  description: 'Classic Green+',
                  is_composite_price: true,
                  is_tax_inclusive: null,
                  price_components: [],
                  price_display_in_journeys: 'show_price',
                  pricing_model: null,
                  tiers: [],
                  type: null,
                  unit_amount: 0,
                  unit_amount_currency: 'EUR',
                  unit_amount_decimal: '0.00',
                  variable_price: null,
                  billing_duration_amount: null,
                  billing_duration_unit: null,
                  billing_period: null,
                  internal_description: 'Classic Green+',
                  notice_time_amount: null,
                  notice_time_unit: null,
                  renewal_duration_amount: null,
                  renewal_duration_unit: null,
                  termination_time_amount: null,
                  termination_time_unit: null,
                  unit: null,
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:27.709Z',
                  _updated_at: '2025-05-23T06:23:55.130Z',
                  _title: 'Classic Green+',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  $relation: {
                    entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
                  }
                },
                {
                  _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                  _schema: 'price',
                  _tags: ['Commodity', 'Strom'],
                  active: true,
                  billing_duration_unit: 'months',
                  description: 'Dynamic Green+',
                  is_composite_price: true,
                  is_tax_inclusive: true,
                  notice_time_unit: 'months',
                  price_components: [],
                  price_display_in_journeys: 'show_price',
                  pricing_model: 'per_unit',
                  renewal_duration_unit: 'months',
                  termination_time_unit: 'months',
                  tiers: [],
                  type: 'one_time',
                  unit_amount: 0,
                  unit_amount_currency: 'EUR',
                  unit_amount_decimal: '0.00',
                  variable_price: false,
                  billing_period: 'weekly',
                  internal_description: 'Dynamic Green+',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:27.918Z',
                  _updated_at: '2025-05-23T06:24:15.056Z',
                  _title: 'Dynamic Green+',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  $relation: {
                    entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac'
                  }
                }
              ],
              product_downloads: [
                {
                  _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Datenschutz'],
                  _title: 'Datenschutzinformationen.pdf',
                  access_control: 'public-read',
                  filename: 'Datenschutzinformationen.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'Datenschutz'],
                      _title: 'Datenschutzinformationen.pdf',
                      access_control: 'public-read',
                      filename: 'Datenschutzinformationen.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:20.522Z',
                  _updated_at: '2025-04-04T07:57:21.022Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                  $relation: {
                    entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                  }
                },
                {
                  _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'AGB'],
                  _title: 'AGB.pdf',
                  access_control: 'public-read',
                  filename: 'AGB.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'AGB'],
                      _title: 'AGB.pdf',
                      access_control: 'public-read',
                      filename: 'AGB.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:21.247Z',
                  _updated_at: '2025-04-04T07:57:21.704Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                  $relation: {
                    entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                  }
                },
                {
                  _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Widerrufsformular'],
                  _title: 'Muster-Widerrufsformular.pdf',
                  access_control: 'public-read',
                  filename: 'Muster-Widerrufsformular.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'Widerrufsformular'],
                      _title: 'Muster-Widerrufsformular.pdf',
                      access_control: 'public-read',
                      filename: 'Muster-Widerrufsformular.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:21.101Z',
                  _updated_at: '2025-04-04T07:57:21.569Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                  $relation: {
                    entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                  }
                },
                {
                  _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Preisblatt'],
                  _title: 'Preisblatt.pdf',
                  access_control: 'public-read',
                  filename: 'Preisblatt.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'Preisblatt'],
                      _title: 'Preisblatt.pdf',
                      access_control: 'public-read',
                      filename: 'Preisblatt.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:20.386Z',
                  _updated_at: '2025-04-04T07:57:20.823Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                  $relation: {
                    entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                  }
                }
              ],
              product_images: [],
              type: 'product',
              _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
              _title: 'Strom Green+',
              _messages: {}
            },
            taxes: [
              {
                tax: {
                  _manifest: [
                    '956e9f44-0d8e-4d50-af85-e528fb130d64',
                    'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                    '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                    '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                    '4573c148-9fa1-4de8-bb05-964a01690789'
                  ],
                  _schema: 'tax',
                  active: true,
                  description: '19%',
                  rate: '19',
                  region: 'DE',
                  type: 'VAT',
                  _id: '170d696a-611a-4627-a904-137741027989',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:09:29.464Z',
                  _updated_at: '2025-04-04T07:57:19.848Z',
                  _title: '19%',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  }
                },
                amount: 0
              }
            ],
            type: 'recurring',
            billing_period: 'monthly',
            unit_amount_net: 20,
            unit_amount_gross: 24,
            amount_subtotal: 0,
            amount_total: 0,
            amount_tax: 0,
            dynamic_tariff: {
              interval: 'hourly',
              markup: 0,
              markup_amount: 15,
              markup_amount_decimal: '0.1511',
              markup_decimal: '0.00',
              mode: 'day_ahead_market',
              markup_amount_net: 13,
              markup_amount_gross: 15,
              unit_amount_net: 8,
              unit_amount_gross: 9,
              unit_amount_net_decimal: '0.0779',
              unit_amount_gross_decimal: '0.092701',
              markup_amount_net_decimal: '0.126974789916',
              markup_amount_gross_decimal: '0.1511'
            },
            currency: 'EUR',
            is_tax_inclusive: true,
            unit_amount_net_decimal: '0.204874789916',
            unit_amount_gross_decimal: '0.243801',
            amount_subtotal_decimal: '0',
            amount_total_decimal: '0'
          },
          {
            price_id: '9341c8ea-0245-4e32-b771-6b0290428e51',
            product_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
            quantity: 1,
            description: 'Umlagen, Abgaben, Steuern, etc.',
            unit_amount: 16,
            unit_amount_decimal: '0.1611',
            pricing_model: 'per_unit',
            _price: {
              _id: '9341c8ea-0245-4e32-b771-6b0290428e51',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom'],
              active: true,
              billing_duration_unit: 'months',
              description: 'Umlagen, Abgaben, Steuern, etc.',
              is_tax_inclusive: true,
              notice_time_unit: 'months',
              price_display_in_journeys: 'show_price',
              pricing_model: 'per_unit',
              renewal_duration_unit: 'months',
              tax: [
                {
                  _manifest: [
                    '956e9f44-0d8e-4d50-af85-e528fb130d64',
                    'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                    '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                    '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                    '4573c148-9fa1-4de8-bb05-964a01690789'
                  ],
                  _schema: 'tax',
                  active: true,
                  description: '19%',
                  rate: '19',
                  region: 'DE',
                  type: 'VAT',
                  _id: '170d696a-611a-4627-a904-137741027989',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:09:29.464Z',
                  _updated_at: '2025-04-04T07:57:19.848Z',
                  _title: '19%',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  }
                }
              ],
              termination_time_unit: 'months',
              tiers: [],
              type: 'recurring',
              unit: 'kwh',
              unit_amount: 16,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '0.1611',
              variable_price: true,
              billing_period: 'monthly',
              internal_description: 'Umlagen, Abgaben, Steuern, etc.',
              _title: 'Umlagen, Abgaben, Steuern, etc.',
              averageMarketPrice: {
                market: 'day_ahead',
                bidding_zone: 'DE-LU',
                price: {
                  timestamp:
                    '2025-04-01T00:00:00.000+02:00/2025-04-30T23:59:59.999+02:00',
                  unit_amount: 7.79,
                  unit_amount_decimal: '0.0779',
                  unit_amount_currency: 'EUR'
                },
                _meta: {
                  timestamp: 1747981644144,
                  signature:
                    'f391184cf47d00e988962261f36b7b47dc8169298ec11a04c52c0bb16af49c48'
                },
                inputs: {
                  market: 'day_ahead',
                  bidding_zone: 'DE-LU',
                  from: '2025-04-01',
                  to: '2025-04-30'
                }
              }
            },
            _product: {
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom', 'dont-touch'],
              active: true,
              categories: [],
              description: 'Außerhalb der Grundversorgung',
              feature: [
                {
                  _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                  _tags: [],
                  feature: '100% Ökostrom',
                  value: ''
                },
                {
                  _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                  _tags: [],
                  feature: 'Erstlaufzeit bis 31.12.2025',
                  value: ''
                },
                {
                  _id: 'SbRtgtY6flxvlR1M-LaHi',
                  _tags: [],
                  feature: 'Kündigungsfrist 1 Monat',
                  value: ''
                },
                {
                  _id: 'v07rw_RfinlcUOfQD0h9S',
                  _tags: [],
                  feature:
                    '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                  value: ''
                }
              ],
              internal_name: 'Strom Green+',
              name: 'Strom Green+',
              price_options: [
                {
                  _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                  _schema: 'price',
                  _tags: ['Commodity', 'Strom'],
                  active: true,
                  description: 'Classic Green+',
                  is_composite_price: true,
                  is_tax_inclusive: null,
                  price_components: [],
                  price_display_in_journeys: 'show_price',
                  pricing_model: null,
                  tiers: [],
                  type: null,
                  unit_amount: 0,
                  unit_amount_currency: 'EUR',
                  unit_amount_decimal: '0.00',
                  variable_price: null,
                  billing_duration_amount: null,
                  billing_duration_unit: null,
                  billing_period: null,
                  internal_description: 'Classic Green+',
                  notice_time_amount: null,
                  notice_time_unit: null,
                  renewal_duration_amount: null,
                  renewal_duration_unit: null,
                  termination_time_amount: null,
                  termination_time_unit: null,
                  unit: null,
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:27.709Z',
                  _updated_at: '2025-05-23T06:23:55.130Z',
                  _title: 'Classic Green+',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  $relation: {
                    entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
                  }
                },
                {
                  _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                  _schema: 'price',
                  _tags: ['Commodity', 'Strom'],
                  active: true,
                  billing_duration_unit: 'months',
                  description: 'Dynamic Green+',
                  is_composite_price: true,
                  is_tax_inclusive: true,
                  notice_time_unit: 'months',
                  price_components: [],
                  price_display_in_journeys: 'show_price',
                  pricing_model: 'per_unit',
                  renewal_duration_unit: 'months',
                  termination_time_unit: 'months',
                  tiers: [],
                  type: 'one_time',
                  unit_amount: 0,
                  unit_amount_currency: 'EUR',
                  unit_amount_decimal: '0.00',
                  variable_price: false,
                  billing_period: 'weekly',
                  internal_description: 'Dynamic Green+',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:27.918Z',
                  _updated_at: '2025-05-23T06:24:15.056Z',
                  _title: 'Dynamic Green+',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  $relation: {
                    entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac'
                  }
                }
              ],
              product_downloads: [
                {
                  _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Datenschutz'],
                  _title: 'Datenschutzinformationen.pdf',
                  access_control: 'public-read',
                  filename: 'Datenschutzinformationen.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'Datenschutz'],
                      _title: 'Datenschutzinformationen.pdf',
                      access_control: 'public-read',
                      filename: 'Datenschutzinformationen.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:20.522Z',
                  _updated_at: '2025-04-04T07:57:21.022Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                  $relation: {
                    entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                  }
                },
                {
                  _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'AGB'],
                  _title: 'AGB.pdf',
                  access_control: 'public-read',
                  filename: 'AGB.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'AGB'],
                      _title: 'AGB.pdf',
                      access_control: 'public-read',
                      filename: 'AGB.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:21.247Z',
                  _updated_at: '2025-04-04T07:57:21.704Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                  $relation: {
                    entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                  }
                },
                {
                  _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Widerrufsformular'],
                  _title: 'Muster-Widerrufsformular.pdf',
                  access_control: 'public-read',
                  filename: 'Muster-Widerrufsformular.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'Widerrufsformular'],
                      _title: 'Muster-Widerrufsformular.pdf',
                      access_control: 'public-read',
                      filename: 'Muster-Widerrufsformular.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:21.101Z',
                  _updated_at: '2025-04-04T07:57:21.569Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                  $relation: {
                    entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                  }
                },
                {
                  _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Preisblatt'],
                  _title: 'Preisblatt.pdf',
                  access_control: 'public-read',
                  filename: 'Preisblatt.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'Preisblatt'],
                      _title: 'Preisblatt.pdf',
                      access_control: 'public-read',
                      filename: 'Preisblatt.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:20.386Z',
                  _updated_at: '2025-04-04T07:57:20.823Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                  $relation: {
                    entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                  }
                }
              ],
              product_images: [],
              type: 'product',
              _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
              _title: 'Strom Green+',
              _messages: {}
            },
            taxes: [
              {
                tax: {
                  _manifest: [
                    '956e9f44-0d8e-4d50-af85-e528fb130d64',
                    'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                    '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                    '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                    '4573c148-9fa1-4de8-bb05-964a01690789'
                  ],
                  _schema: 'tax',
                  active: true,
                  description: '19%',
                  rate: '19',
                  region: 'DE',
                  type: 'VAT',
                  _id: '170d696a-611a-4627-a904-137741027989',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:09:29.464Z',
                  _updated_at: '2025-04-04T07:57:19.848Z',
                  _title: '19%',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  }
                },
                amount: 0
              }
            ],
            type: 'recurring',
            billing_period: 'monthly',
            unit_amount_net: 14,
            unit_amount_gross: 16,
            amount_subtotal: 0,
            amount_total: 0,
            amount_tax: 0,
            currency: 'EUR',
            is_tax_inclusive: true,
            unit_amount_net_decimal: '0.135378151261',
            unit_amount_gross_decimal: '0.1611',
            amount_subtotal_decimal: '0',
            amount_total_decimal: '0'
          }
        ],
        _price: {
          _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
          _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
          _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
          _tags: ['Commodity', 'Strom'],
          active: true,
          billing_duration_unit: 'months',
          description: 'Dynamic Green+',
          is_composite_price: true,
          is_tax_inclusive: true,
          notice_time_unit: 'months',
          price_components: [
            {
              _id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
              _manifest: [
                '3babbfe8-80a2-4e19-b9e6-3d6d4fa22730',
                '50fb9921-3b0d-430a-9211-5b741e601008',
                '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                '4573c148-9fa1-4de8-bb05-964a01690789'
              ],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom'],
              active: true,
              description: 'Grundpreis',
              is_tax_inclusive: true,
              price_display_in_journeys: 'show_price',
              pricing_model: 'tiered_volume',
              tax: {
                $relation: [
                  {
                    entity_id: '170d696a-611a-4627-a904-137741027989'
                  }
                ]
              },
              tiers: [],
              type: 'recurring',
              unit_amount: 1300,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '13',
              variable_price: true,
              billing_duration_amount: '',
              billing_duration_unit: null,
              billing_period: 'monthly',
              internal_description: 'Grundpreis',
              notice_time_amount: null,
              notice_time_unit: null,
              price_components: null,
              renewal_duration_amount: null,
              renewal_duration_unit: null,
              termination_time_amount: null,
              termination_time_unit: null,
              _title: 'Grundpreis'
            },
            {
              _id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom'],
              active: true,
              billing_duration_unit: 'months',
              description: 'Energie Spotmarktpreis',
              is_tax_inclusive: true,
              notice_time_unit: 'months',
              price_display_in_journeys: 'show_price',
              pricing_model: 'dynamic_tariff',
              renewal_duration_unit: 'months',
              tax: {
                $relation: [
                  {
                    entity_id: '170d696a-611a-4627-a904-137741027989'
                  }
                ]
              },
              termination_time_unit: 'months',
              tiers: [],
              type: 'recurring',
              unit: 'kwh',
              unit_amount: 0,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '0.00',
              variable_price: true,
              billing_period: 'monthly',
              dynamic_tariff: {
                interval: 'hourly',
                markup: 0,
                markup_amount: 15,
                markup_amount_decimal: '0.1511',
                markup_decimal: '0.00',
                mode: 'day_ahead_market'
              },
              internal_description: 'Energie Spotmarktpreis',
              _title: 'Energie Spotmarktpreis'
            },
            {
              _id: '9341c8ea-0245-4e32-b771-6b0290428e51',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom'],
              active: true,
              billing_duration_unit: 'months',
              description: 'Umlagen, Abgaben, Steuern, etc.',
              is_tax_inclusive: true,
              notice_time_unit: 'months',
              price_display_in_journeys: 'show_price',
              pricing_model: 'per_unit',
              renewal_duration_unit: 'months',
              tax: {
                $relation: [
                  {
                    entity_id: '170d696a-611a-4627-a904-137741027989'
                  }
                ]
              },
              termination_time_unit: 'months',
              tiers: [],
              type: 'recurring',
              unit: 'kwh',
              unit_amount: 16,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '0.1611',
              variable_price: true,
              billing_period: 'monthly',
              internal_description: 'Umlagen, Abgaben, Steuern, etc.',
              _title: 'Umlagen, Abgaben, Steuern, etc.'
            }
          ],
          price_display_in_journeys: 'show_price',
          pricing_model: 'per_unit',
          renewal_duration_unit: 'months',
          termination_time_unit: 'months',
          tiers: [],
          type: 'one_time',
          unit_amount: 0,
          unit_amount_currency: 'EUR',
          unit_amount_decimal: '0.00',
          variable_price: false,
          billing_period: 'weekly',
          internal_description: 'Dynamic Green+',
          _title: 'Dynamic Green+'
        },
        _product: {
          _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
          _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
          _tags: ['Commodity', 'Strom', 'dont-touch'],
          active: true,
          categories: [],
          description: 'Außerhalb der Grundversorgung',
          feature: [
            {
              _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
              _tags: [],
              feature: '100% Ökostrom',
              value: ''
            },
            {
              _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
              _tags: [],
              feature: 'Erstlaufzeit bis 31.12.2025',
              value: ''
            },
            {
              _id: 'SbRtgtY6flxvlR1M-LaHi',
              _tags: [],
              feature: 'Kündigungsfrist 1 Monat',
              value: ''
            },
            {
              _id: 'v07rw_RfinlcUOfQD0h9S',
              _tags: [],
              feature:
                '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
              value: ''
            }
          ],
          internal_name: 'Strom Green+',
          name: 'Strom Green+',
          price_options: [
            {
              _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _schema: 'price',
              _tags: ['Commodity', 'Strom'],
              active: true,
              description: 'Classic Green+',
              is_composite_price: true,
              is_tax_inclusive: null,
              price_components: [],
              price_display_in_journeys: 'show_price',
              pricing_model: null,
              tiers: [],
              type: null,
              unit_amount: 0,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '0.00',
              variable_price: null,
              billing_duration_amount: null,
              billing_duration_unit: null,
              billing_period: null,
              internal_description: 'Classic Green+',
              notice_time_amount: null,
              notice_time_unit: null,
              renewal_duration_amount: null,
              renewal_duration_unit: null,
              termination_time_amount: null,
              termination_time_unit: null,
              unit: null,
              _org: 'test-org',
              _owners: [
                {
                  org_id: 'test-org',
                  user_id: '140034'
                }
              ],
              _created_at: '2025-04-04T07:57:27.709Z',
              _updated_at: '2025-05-23T06:23:55.130Z',
              _title: 'Classic Green+',
              _acl: {
                view: ['org_16246022'],
                edit: ['org_16246022'],
                delete: ['org_16246022']
              },
              $relation: {
                entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
              }
            },
            {
              _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _schema: 'price',
              _tags: ['Commodity', 'Strom'],
              active: true,
              billing_duration_unit: 'months',
              description: 'Dynamic Green+',
              is_composite_price: true,
              is_tax_inclusive: true,
              notice_time_unit: 'months',
              price_components: [],
              price_display_in_journeys: 'show_price',
              pricing_model: 'per_unit',
              renewal_duration_unit: 'months',
              termination_time_unit: 'months',
              tiers: [],
              type: 'one_time',
              unit_amount: 0,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '0.00',
              variable_price: false,
              billing_period: 'weekly',
              internal_description: 'Dynamic Green+',
              _org: 'test-org',
              _owners: [
                {
                  org_id: 'test-org',
                  user_id: '140034'
                }
              ],
              _created_at: '2025-04-04T07:57:27.918Z',
              _updated_at: '2025-05-23T06:24:15.056Z',
              _title: 'Dynamic Green+',
              _acl: {
                view: ['org_16246022'],
                edit: ['org_16246022'],
                delete: ['org_16246022']
              },
              $relation: {
                entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac'
              }
            }
          ],
          product_downloads: [
            {
              _id: '26495f53-c961-4214-a417-9a7b05e039a1',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: [],
              _tags: ['Commodity', 'Datenschutz'],
              _title: 'Datenschutzinformationen.pdf',
              access_control: 'public-read',
              filename: 'Datenschutzinformationen.pdf',
              mime_type: 'application/pdf',
              type: 'document',
              category: 'unknown',
              file_entity_id: '',
              size_bytes: 11451,
              readable_size: '11.18 KB',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
              },
              versions: [
                {
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Datenschutz'],
                  _title: 'Datenschutzinformationen.pdf',
                  access_control: 'public-read',
                  filename: 'Datenschutzinformationen.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                  }
                }
              ],
              _schema: 'file',
              _org: 'test-org',
              _owners: [
                {
                  org_id: 'test-org',
                  user_id: '140034'
                }
              ],
              _created_at: '2025-04-04T07:57:20.522Z',
              _updated_at: '2025-04-04T07:57:21.022Z',
              _acl: {
                view: ['org_16246022'],
                edit: ['org_16246022'],
                delete: ['org_16246022']
              },
              source_url:
                'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
              $relation: {
                entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
              }
            },
            {
              _id: '570756ec-796f-41b7-981c-e731ef4905ef',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: [],
              _tags: ['Commodity', 'AGB'],
              _title: 'AGB.pdf',
              access_control: 'public-read',
              filename: 'AGB.pdf',
              mime_type: 'application/pdf',
              type: 'document',
              category: 'unknown',
              file_entity_id: '',
              size_bytes: 11451,
              readable_size: '11.18 KB',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
              },
              versions: [
                {
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'AGB'],
                  _title: 'AGB.pdf',
                  access_control: 'public-read',
                  filename: 'AGB.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                  }
                }
              ],
              _schema: 'file',
              _org: 'test-org',
              _owners: [
                {
                  org_id: 'test-org',
                  user_id: '140034'
                }
              ],
              _created_at: '2025-04-04T07:57:21.247Z',
              _updated_at: '2025-04-04T07:57:21.704Z',
              _acl: {
                view: ['org_16246022'],
                edit: ['org_16246022'],
                delete: ['org_16246022']
              },
              source_url:
                'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
              $relation: {
                entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
              }
            },
            {
              _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: [],
              _tags: ['Commodity', 'Widerrufsformular'],
              _title: 'Muster-Widerrufsformular.pdf',
              access_control: 'public-read',
              filename: 'Muster-Widerrufsformular.pdf',
              mime_type: 'application/pdf',
              type: 'document',
              category: 'unknown',
              file_entity_id: '',
              size_bytes: 11451,
              readable_size: '11.18 KB',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
              },
              versions: [
                {
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Widerrufsformular'],
                  _title: 'Muster-Widerrufsformular.pdf',
                  access_control: 'public-read',
                  filename: 'Muster-Widerrufsformular.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                  }
                }
              ],
              _schema: 'file',
              _org: 'test-org',
              _owners: [
                {
                  org_id: 'test-org',
                  user_id: '140034'
                }
              ],
              _created_at: '2025-04-04T07:57:21.101Z',
              _updated_at: '2025-04-04T07:57:21.569Z',
              _acl: {
                view: ['org_16246022'],
                edit: ['org_16246022'],
                delete: ['org_16246022']
              },
              source_url:
                'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
              $relation: {
                entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
              }
            },
            {
              _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: [],
              _tags: ['Commodity', 'Preisblatt'],
              _title: 'Preisblatt.pdf',
              access_control: 'public-read',
              filename: 'Preisblatt.pdf',
              mime_type: 'application/pdf',
              type: 'document',
              category: 'unknown',
              file_entity_id: '',
              size_bytes: 11451,
              readable_size: '11.18 KB',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
              },
              versions: [
                {
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Preisblatt'],
                  _title: 'Preisblatt.pdf',
                  access_control: 'public-read',
                  filename: 'Preisblatt.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                  }
                }
              ],
              _schema: 'file',
              _org: 'test-org',
              _owners: [
                {
                  org_id: 'test-org',
                  user_id: '140034'
                }
              ],
              _created_at: '2025-04-04T07:57:20.386Z',
              _updated_at: '2025-04-04T07:57:20.823Z',
              _acl: {
                view: ['org_16246022'],
                edit: ['org_16246022'],
                delete: ['org_16246022']
              },
              source_url:
                'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
              $relation: {
                entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
              }
            }
          ],
          product_images: [],
          type: 'product',
          _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
          _title: 'Strom Green+',
          _messages: {}
        },
        external_price_metadata: {
          market: 'day_ahead',
          bidding_zone: 'DE-LU',
          price: {
            timestamp:
              '2025-04-01T00:00:00.000+02:00/2025-04-30T23:59:59.999+02:00',
            unit_amount: 7.79,
            unit_amount_decimal: '0.0779',
            unit_amount_currency: 'EUR'
          },
          _meta: {
            timestamp: 1747981644144,
            signature:
              'f391184cf47d00e988962261f36b7b47dc8169298ec11a04c52c0bb16af49c48'
          },
          inputs: {
            market: 'day_ahead',
            bidding_zone: 'DE-LU',
            from: '2025-04-01',
            to: '2025-04-30'
          }
        },
        external_fees_mappings: [
          {
            price_id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
            amount_total: 7.79,
            amount_total_decimal: '0.0779'
          }
        ],
        price_mappings: [
          {
            price_id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
            value: 0
          },
          {
            price_id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
            value: 0
          },
          {
            price_id: '9341c8ea-0245-4e32-b771-6b0290428e51',
            value: 0
          }
        ],
        currency: 'EUR',
        amount_subtotal: 0,
        amount_total: 0,
        total_details: {
          amount_tax: 0,
          breakdown: {
            taxes: [
              {
                tax: {
                  _id: '170d696a-611a-4627-a904-137741027989',
                  type: 'VAT',
                  rate: '19'
                },
                amount: 0
              }
            ],
            recurrences: [
              {
                type: 'recurring',
                billing_period: 'monthly',
                unit_amount_gross: 40,
                amount_subtotal: 0,
                amount_total: 0,
                amount_subtotal_decimal: '0',
                amount_total_decimal: '0',
                amount_tax: 0
              }
            ],
            recurrencesByTax: [
              {
                type: 'recurring',
                billing_period: 'monthly',
                amount_total: 0,
                amount_subtotal: 0,
                amount_tax: 0,
                tax: {
                  tax: {
                    _id: '170d696a-611a-4627-a904-137741027989',
                    type: 'VAT',
                    rate: '19'
                  },
                  amount: 0
                }
              }
            ],
            cashbacks: []
          }
        },
        amount_tax: 0,
        amount_subtotal_decimal: '0',
        amount_total_decimal: '0'
      }
    ],
    amount_subtotal: 0,
    amount_total: 0,
    total_details: {
      amount_tax: 0,
      breakdown: {
        taxes: [
          {
            tax: {
              _id: '170d696a-611a-4627-a904-137741027989',
              type: 'VAT',
              rate: '19'
            },
            amount: 0
          }
        ],
        recurrences: [
          {
            type: 'recurring',
            billing_period: 'monthly',
            unit_amount_gross: 40,
            amount_subtotal: 0,
            amount_total: 0,
            amount_subtotal_decimal: '0',
            amount_total_decimal: '0',
            amount_tax: 0
          }
        ],
        recurrencesByTax: [
          {
            type: 'recurring',
            billing_period: 'monthly',
            amount_total: 0,
            amount_subtotal: 0,
            amount_tax: 0,
            tax: {
              tax: {
                _id: '170d696a-611a-4627-a904-137741027989',
                type: 'VAT',
                rate: '19'
              },
              amount: 0
            }
          }
        ],
        cashbacks: []
      }
    },
    currency: 'EUR',
    redeemed_promos: [],
    start_date: '2025-01-01',
    end_date: null,
    _tags: ['dont-touch'],
    amount_tax: 0,
    prices: {
      $relation: [
        {
          entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
          _schema: 'price',
          _tags: []
        }
      ]
    },
    products: {
      $relation: [
        {
          entity_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
          _schema: 'product',
          _tags: []
        }
      ]
    },
    notice_time_amount: '2',
    billing_address: {
      $relation_ref: [
        {
          entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
          path: 'address',
          _id: 'L6sB14Iori1DB0PodxizK'
        }
      ]
    },
    delivery_address: {
      $relation_ref: [
        {
          entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
          path: 'address',
          _id: 'L6sB14Iori1DB0PodxizK'
        }
      ]
    },
    payment: {
      $relation_ref: [
        {
          entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
          path: 'payment',
          _id: 'UvxxbZ13mCnwchDZxheL8'
        }
      ]
    }
  },
  orders: [],
  meters: [
    {
      _id: '3c95352d-32e2-486d-9991-d565f3b84e11',
      meter_type: 'smart-meter',
      meter_number: '1ESY2158347841311',
      sector: 'power',
      status: 'active',
      _tags: [],
      _schema: 'meter',
      _org: 'test-org',
      _created_at: '2025-05-07T11:40:35.712Z',
      _title: '1ESY2158347841311',
      contract: {
        $relation: [
          {
            entity_id: '78d3639c-ef63-4517-9942-3407dda87de7'
          }
        ]
      },
      _updated_at: '2025-05-23T06:18:09.077Z',
      obis_number: '2-3:6.8.9',
      direction: 'feed-in',
      tariff_type: 'et',
      unit: 'kWh',
      transformer_ratio: '1',
      counters: {
        $relation: [
          {
            entity_id: 'bde93dd0-bfa5-4fec-8f73-790707c889f5',
            _schema: 'meter_counter',
            _tags: []
          }
        ]
      },
      _files: {
        $relation: [
          {
            entity_id: '3bddb912-9549-4aa9-a4a4-f6ae4696226b'
          },
          {
            entity_id: '3182215d-01d7-49c7-aab2-a1cc5d2ced46'
          },
          {
            entity_id: '4a32f2cd-f847-41f4-b17b-c5c89e3dc78c'
          },
          {
            entity_id: '70550f17-7337-4514-9044-0962f000e949'
          },
          {
            entity_id: 'b075a5c7-9484-4b10-893d-9a7dbb2a636b'
          }
        ]
      },
      ma_lo_id: 'DE228554800',
      used_for: 'Haushaltsstrom',
      manufacturer: 'EMH',
      calibration_date: '2025-01-01',
      location: 'Werkstatt',
      customer: {
        $relation: [
          {
            entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
            _schema: 'contact',
            _tags: []
          }
        ]
      },
      $relation: {
        entity_id: '3c95352d-32e2-486d-9991-d565f3b84e11',
        _tags: [],
        attribute: 'meters'
      }
    },
    {
      ma_lo_id: 'DE852287503',
      meter_type: 'electronic-meter',
      tariff_type: 'et',
      meter_number: '1ESY6311780912661',
      sector: 'power',
      used_for: 'Haushaltsstrom',
      manufacturer: 'Sagemcom',
      calibration_date: '2025-01-01',
      location: 'Keller Oben Mitte',
      status: 'active',
      _tags: ['dont-touch'],
      _schema: 'meter',
      _id: 'e250a873-fe35-4b24-b502-19a84347200d',
      _org: 'test-org',
      _created_at: '2025-05-19T11:40:47.144Z',
      _title: '1ESY6311780912661',
      counters: {
        $relation: [
          {
            entity_id: 'c2dd7872-6ac0-4d7c-85a2-8f7775315832',
            _tags: []
          }
        ]
      },
      contract: {
        $relation: [
          {
            entity_id: 'a68e4801-979c-4fee-b43f-0dbacb06634e'
          },
          {
            entity_id: '78d3639c-ef63-4517-9942-3407dda87de7'
          }
        ]
      },
      customer: {
        $relation: [
          {
            entity_id: '6fd04058-92c9-43bc-ab10-29a2d6808be3',
            _schema: 'contact',
            _tags: []
          }
        ]
      },
      _files: {
        $relation: [
          {
            entity_id: 'a18a9f26-d973-48b6-9b1c-27341f0f17ff'
          }
        ]
      },
      _updated_at: '2025-06-17T11:03:26.779Z',
      $relation: {
        entity_id: 'e250a873-fe35-4b24-b502-19a84347200d',
        attribute: 'contract',
        reverse: true
      }
    }
  ],
  files: [],
  relations: [
    {
      _org: 'test-org',
      _schema: 'contact',
      last_name: 'Max',
      first_name: 'Anna',
      email: [
        {
          email: 'maxspark360@gmail.com',
          _id: 'HfAOh-AdruvBugA1FbjQf',
          id: 'q37xcz3'
        }
      ],
      payment: [
        {
          _tags: [],
          _id: 'UvxxbZ13mCnwchDZxheL8',
          data: {
            consent: true,
            fullname: 'Max Spark',
            bic_number: 'INGDDEFFXXX',
            bank_name: 'ING-DiBa',
            iban: 'DE02500105170137075030',
            start_date: '2025-01-01'
          },
          type: 'payment_sepa',
          id: 'eb4tss8'
        },
        {
          _tags: [],
          _id: 'xLMGLijTFmrQilKXlyKU8',
          data: {
            consent: true,
            bic_number: 'INGDDEFFXXX',
            bank_name: 'ING-DiBa',
            iban: 'DE02500105170137075030',
            fullname: 'Max Spark'
          },
          type: 'payment_sepa',
          id: 'frsd5ru'
        },
        {
          _tags: [],
          _id: 'Eo67TPiGhp7NhOtj6Nc5E',
          data: {
            consent: true,
            bic_number: 'INGDDEFFXXX',
            bank_name: 'ING-DiBa',
            iban: 'DE02500105170137075030',
            fullname: 'Max Spark'
          },
          type: 'payment_sepa',
          id: 'h1811tg'
        },
        {
          _tags: [],
          _id: '0vEXDJ9JySVANsfaY5wAe',
          data: {
            consent: true,
            fullname: 'Max Spark',
            bic_number: 'INGDDEFFXXX',
            bank_name: 'ING-DiBa',
            iban: 'DE02500105170137075030'
          },
          type: 'payment_sepa',
          id: '1xu838y'
        }
      ],
      birthdate: '1982-09-01',
      address: [
        {
          country: 'DE',
          city: 'Köln',
          _tags: ['delivery', 'billing'],
          additional_info: 'Penthouse',
          street: 'Adolf-Fischer-Str.',
          street_number: '2',
          _id: 'L6sB14Iori1DB0PodxizK',
          postal_code: '50670',
          id: '4ci2bne'
        }
      ],
      phone: [
        {
          phone: '012341234123',
          _id: 'UAa6m3SewPKOWJJXTXC3G',
          id: 'ewodw6a'
        }
      ],
      _id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
      _created_at: '2025-04-04T09:18:17.430Z',
      _title: 'Max Anna',
      consent_email_marketing: {
        status: 'active',
        identifiers: [
          {
            identifier: 'maxspark360@gmail.com',
            status: 'active'
          }
        ]
      },
      consent_sms_marketing: {
        status: 'active',
        identifiers: [
          {
            identifier: '012341234123',
            status: 'active'
          }
        ]
      },
      consent_phone_call: {
        status: 'active',
        identifiers: [
          {
            identifier: '012341234123',
            status: 'active'
          }
        ]
      },
      consent_print_marketing: {
        status: 'unknown',
        identifiers: [
          {
            identifier: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
            status: 'unknown'
          }
        ]
      },
      _files: {
        $relation: [
          {
            entity_id: 'a3214d39-9ee7-4bb9-bd56-9ae35bef0333'
          },
          {
            entity_id: 'a709ab66-7d09-4666-b3b9-9601aad41a70'
          },
          {
            entity_id: '5b03a66f-0385-4533-b780-62052cbfeeaa'
          },
          {
            entity_id: '2e8c7821-2551-41aa-b821-894c197ba420'
          },
          {
            entity_id: 'ef7d78d6-7d65-4892-9266-0f9584ab277b'
          },
          {
            entity_id: 'c0ef117f-9416-4240-8a94-694c6b67511f'
          },
          {
            entity_id: '1e1f456a-926f-43fb-a581-873aa693bbdd'
          },
          {
            entity_id: 'e095ebfc-6845-4851-94c4-cf32c71383b4'
          }
        ]
      },
      first_ecp_login: '2025-04-04T13:56:15.807Z',
      _pending_changes: {},
      journey_actions: [
        {
          journey_id: '66877380-0662-11f0-a9ca-4f3dc91aee12',
          action_label: {
            en: 'Move or Terminate Contract',
            de: 'Move or Terminate Contract'
          },
          slug: 'contract'
        },
        {
          journey_id: '62144be0-05a7-11f0-9864-af17fa9de986',
          action_label: {
            en: 'IBAN Change',
            de: 'IBAN Change'
          },
          slug: 'contract'
        },
        {
          journey_id: '597b10d0-25d3-11f0-a06f-fd52871531fc',
          action_label: {
            en: 'General Request',
            de: 'Allgemeine Anfrage'
          },
          slug: 'contract',
          rules: []
        }
      ],
      files: [
        {
          filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
          access_control: 'public-read',
          document_type: 'document',
          _tags: [
            'Commodity',
            'Bestellbestätigung',
            'B2C',
            'message_attachment'
          ],
          _purpose: [
            'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
            'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
            '6cf77479-becb-408b-a72e-b342bdc87f09',
            '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
          ],
          shared_with_end_customer: true,
          type: 'document',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
          size_bytes: 156167,
          readable_size: '152.51 KB',
          mime_type: 'application/pdf',
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
          },
          versions: [
            {
              filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
              access_control: 'public-read',
              document_type: 'document',
              _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
              _purpose: [
                'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                '6cf77479-becb-408b-a72e-b342bdc87f09',
                '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
              ],
              shared_with_end_customer: true,
              type: 'document',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
              size_bytes: 156167,
              readable_size: '152.51 KB',
              mime_type: 'application/pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
              }
            }
          ],
          _schema: 'file',
          _id: '1e1f456a-926f-43fb-a581-873aa693bbdd',
          _org: 'test-org',
          _created_at: '2025-04-07T07:16:36.872Z',
          _title: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
          _updated_at: '2025-04-07T07:16:38.668Z'
        },
        {
          filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
          access_control: 'public-read',
          document_type: 'document',
          _tags: [
            'Commodity',
            'Bestellbestätigung',
            'B2C',
            'message_attachment'
          ],
          _purpose: [
            'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
            'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
            '6cf77479-becb-408b-a72e-b342bdc87f09',
            '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
          ],
          shared_with_end_customer: true,
          type: 'document',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
          size_bytes: 153036,
          readable_size: '149.45 KB',
          mime_type: 'application/pdf',
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
          },
          versions: [
            {
              filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
              access_control: 'public-read',
              document_type: 'document',
              _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
              _purpose: [
                'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                '6cf77479-becb-408b-a72e-b342bdc87f09',
                '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
              ],
              shared_with_end_customer: true,
              type: 'document',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
              size_bytes: 153036,
              readable_size: '149.45 KB',
              mime_type: 'application/pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
              }
            }
          ],
          _schema: 'file',
          _id: '5b03a66f-0385-4533-b780-62052cbfeeaa',
          _org: 'test-org',
          _created_at: '2025-04-07T07:00:37.276Z',
          _title: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
          _updated_at: '2025-04-07T07:00:38.801Z'
        },
        {
          filename: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
          access_control: 'public-read',
          document_type: 'document',
          _tags: [
            'Commodity',
            'Bestellbestätigung',
            'B2C',
            'message_attachment'
          ],
          _purpose: [
            'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
            'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
            '6cf77479-becb-408b-a72e-b342bdc87f09',
            '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
          ],
          shared_with_end_customer: true,
          type: 'document',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
          size_bytes: 156303,
          readable_size: '152.64 KB',
          mime_type: 'application/pdf',
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
          },
          versions: [
            {
              filename: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
              access_control: 'public-read',
              document_type: 'document',
              _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
              _purpose: [
                'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                '6cf77479-becb-408b-a72e-b342bdc87f09',
                '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
              ],
              shared_with_end_customer: true,
              type: 'document',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
              size_bytes: 156303,
              readable_size: '152.64 KB',
              mime_type: 'application/pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
              }
            }
          ],
          _schema: 'file',
          _id: 'a3214d39-9ee7-4bb9-bd56-9ae35bef0333',
          _org: 'test-org',
          _created_at: '2025-04-04T13:52:22.441Z',
          _title: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
          _updated_at: '2025-04-04T13:52:24.321Z'
        }
      ],
      language: 'en',
      customer_number: '1234567880',
      salutation: 'Mr.',
      inbetriebnahme: false,
      _updated_at: '2025-06-12T06:03:13.192Z'
    },
    {
      meter_type: 'smart-meter',
      meter_number: '1ESY2158347841311',
      sector: 'power',
      status: 'active',
      _tags: [],
      _schema: 'meter',
      _id: '3c95352d-32e2-486d-9991-d565f3b84e11',
      _org: 'test-org',
      _created_at: '2025-05-07T11:40:35.712Z',
      _title: '1ESY2158347841311',
      contract: {
        $relation: [
          {
            entity_id: '78d3639c-ef63-4517-9942-3407dda87de7'
          }
        ]
      },
      _updated_at: '2025-05-23T06:18:09.077Z',
      obis_number: '2-3:6.8.9',
      direction: 'feed-in',
      tariff_type: 'et',
      unit: 'kWh',
      transformer_ratio: '1',
      counters: {
        $relation: [
          {
            entity_id: 'bde93dd0-bfa5-4fec-8f73-790707c889f5',
            _schema: 'meter_counter',
            _tags: []
          }
        ]
      },
      _files: {
        $relation: [
          {
            entity_id: '3bddb912-9549-4aa9-a4a4-f6ae4696226b'
          },
          {
            entity_id: '3182215d-01d7-49c7-aab2-a1cc5d2ced46'
          },
          {
            entity_id: '4a32f2cd-f847-41f4-b17b-c5c89e3dc78c'
          },
          {
            entity_id: '70550f17-7337-4514-9044-0962f000e949'
          },
          {
            entity_id: 'b075a5c7-9484-4b10-893d-9a7dbb2a636b'
          }
        ]
      },
      ma_lo_id: 'DE228554800',
      used_for: 'Haushaltsstrom',
      manufacturer: 'EMH',
      calibration_date: '2025-01-01',
      location: 'Werkstatt',
      customer: {
        $relation: [
          {
            entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
            _schema: 'contact',
            _tags: []
          }
        ]
      }
    },
    {
      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
      _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
      _schema: 'product',
      _tags: ['Commodity', 'Strom', 'dont-touch'],
      active: true,
      categories: [],
      description: 'Außerhalb der Grundversorgung',
      feature: [
        {
          _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
          _tags: [],
          feature: '100% Ökostrom',
          value: ''
        },
        {
          _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
          _tags: [],
          feature: 'Erstlaufzeit bis 31.12.2025',
          value: ''
        },
        {
          _id: 'SbRtgtY6flxvlR1M-LaHi',
          _tags: [],
          feature: 'Kündigungsfrist 1 Monat',
          value: ''
        },
        {
          _id: 'v07rw_RfinlcUOfQD0h9S',
          _tags: [],
          feature:
            '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
          value: ''
        }
      ],
      internal_name: 'Strom Green+',
      name: 'Strom Green+',
      price_options: {
        $relation: [
          {
            entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
          },
          {
            entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac'
          }
        ]
      },
      product_downloads: {
        $relation: [
          {
            entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
          },
          {
            entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
          },
          {
            entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
          },
          {
            entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
          }
        ]
      },
      product_images: {
        $relation: []
      },
      type: 'product',
      _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
      _org: 'test-org',
      _created_at: '2025-04-04T07:57:28.791Z',
      _updated_at: '2025-05-23T06:20:58.349Z',
      _title: 'Strom Green+'
    }
  ],
  workflow: [
    {
      version: 2,
      lastUpdateTime: '2025-05-07T11:56:51.445Z',
      trigger: 'AUTOMATIC',
      assignedTo: [],
      creationTime: '2025-04-07T07:20:04.826Z',
      status: 'STARTED',
      wfExecId: '7il6fm2842x',
      updateEntityAttributes: [],
      selectedClosingReasons: [],
      enableECPWorkflow: true,
      name: 'Photovoltaik-Anlage B2C',
      nextOpenStep: {
        entityRefId: '86rv55zhdk3',
        id: '86rv55zhdk3'
      },
      taxonomies: [],
      flow: [
        {
          completedTime: '2025-05-07T11:56:51.439Z',
          name: 'Prüfungsphase',
          id: 'skimkuvala1',
          type: 'SECTION',
          steps: [
            {
              requirements: [],
              startedTime: '2025-04-07T07:20:04.826Z',
              created: '2025-04-07T07:20:04.826Z',
              completedTime: '2025-05-07T11:56:51.439Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              sectionId: 'skimkuvala1',
              type: 'STEP',
              entityRefId: '0f3t0a9hvs8',
              assignedTo: ['101408'],
              lastUpdated: '2025-05-07T11:56:51.439Z',
              ecp: {
                description:
                  'Wir haben Ihre Anfrage erhalten und prüfen sie gerade.',
                enabled: true,
                label: 'Prüfungsphase'
              },
              userIds: [],
              name: 'Prüfung der Daten auf Richtigkeit und Plausibilität',
              id: '0f3t0a9hvs8',
              definitionId: 'zzBis4GA',
              status: 'COMPLETED',
              manuallyCreated: false,
              enabled: true
            }
          ],
          assignedTo: [],
          definitionId: '7tPWZ0un',
          status: 'COMPLETED',
          enabled: true
        },
        {
          name: 'Qualifizierungsphase / Vor-Ort-Termin',
          id: '7k6wxtztrq9',
          type: 'SECTION',
          steps: [
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                }
              ],
              startedTime: '2025-05-07T11:56:51.439Z',
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              sectionId: '7k6wxtztrq9',
              type: 'STEP',
              entityRefId: '86rv55zhdk3',
              automationConfig: {
                flowId: 'ae123b8e-7032-49aa-9785-67fd1785a56b'
              },
              assignedTo: [],
              enabled: true,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              userIds: [],
              name: 'Kontaktaufnahme mit Interessent:in für Terminvereinbarung Vor-Ort-Beratung nicht erfolgreich - Automatisierung ausführen, um Interessent:in zwecks Rückruf zu kontaktieren. Wenn Kontaktaufnahme erfolgreich, Schritt überspringen.',
              id: '86rv55zhdk3',
              definitionId: 'yN5f0rIA',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                }
              ],
              startedTime: '2025-04-07T07:20:04.826Z',
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              description: {
                value:
                  'Nach dem dritten Kontaktversuch: Frist auf +30 Tage setzen. Wenn innerhalb dieser Frist keine Rückmeldung durch Interessent:in Automatisierung ausführen, um Interessent:in über Prozessabbruch zu informieren - Prozess abbrechen und Abbruchgrund nennen. Wenn innerhalb der Frist eine Kontaktaufnahme erfolgt ist, Schritt überspringen.',
                enabled: true
              },
              sectionId: '7k6wxtztrq9',
              type: 'STEP',
              entityRefId: 'l0qfzxahdqk',
              automationConfig: {
                flowId: '497dbc84-9c70-42e6-8aba-e85103ca9ba2'
              },
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              dynamicDueDate: {
                stepId: 'yN5f0rIA',
                timePeriod: 'days',
                numberOfUnits: 1,
                actionTypeCondition: 'STEP_CLOSED'
              },
              userIds: [],
              name: 'Weitere Kontaktaufnahme. Falls Interessent:in wieder nicht erreicht, Aufgabe offen lassen, Frist auf +1 Tag setzen und Automatisierung aus vorherigem Schritt erneut ausführen. Wenn Kontaktaufnahme erfolgreich, Schritt überspringen.',
              id: 'l0qfzxahdqk',
              definitionId: 'EeCC5puB',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                }
              ],
              startedTime: '2025-04-07T07:20:04.826Z',
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'Hinweis: Die Terminbestätigung an Interessent:in wird automatisch versandt.',
                enabled: true
              },
              sectionId: '7k6wxtztrq9',
              type: 'STEP',
              entityRefId: '2g6uebt8qan',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              userIds: [],
              name: 'Kontaktaufnahme mit Interessent:in für Terminvereinbarung Vor-Ort-Beratung - Datum in Feld "1. Vor-Ort-Termin" eintragen.',
              id: '2g6uebt8qan',
              definitionId: '_Y9T46UT',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                }
              ],
              startedTime: '2025-04-07T07:20:04.826Z',
              journey: {
                journeyId: '077da6b0-1126-11f0-bc7b-f59f0d1cc396',
                name: 'Photovoltaik-Anlage Teil 2 (Nachqualifizierung Vor-Ort-Termin)',
                id: '5d915b93-5487-467d-83ce-a9d89dde5b4d'
              },
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die zusätzlichen Informationen und Fotos aus dem Vor-Ort-Termin der Opportunity hinzufügen können. Klicken Sie dafür auf "Photovoltaik-Anlage Teil 2 (Nachqualifizierung Vor-Ort-Termin)".',
                enabled: true
              },
              sectionId: '7k6wxtztrq9',
              type: 'STEP',
              entityRefId: 'owbvqsblhm2',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              ecp: {
                description:
                  'Für die weitere Planung ist es notwendig das Objekt vor Ort zu besichtigen.',
                enabled: true,
                label: 'Vor-Ort-Terminierung'
              },
              userIds: [],
              name: 'Während des Vor-Ort-Termins: Zusätzliche Informationen und Fotos einholen - Daten über verknüpfte Klickstrecke hochladen.',
              id: 'owbvqsblhm2',
              definitionId: 'xMh0jYAR',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                }
              ],
              startedTime: '2025-04-07T07:20:04.826Z',
              journey: {
                journeyId: '0240b570-1126-11f0-8e95-4d06e2df98e6',
                name: 'Allgemein - Uploads Vertrieb',
                id: 'f61cd947-c717-4aaa-a424-6f0a2e91e322'
              },
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'In diesem Schritt ist eine Klickstrecke integriert, in der Sie das Angebot übermitteln können. Klicken Sie dafür auf "Allgemein - Uploads Vertrieb".\n                                \nUploadkategorien:\n- Gebäudegrundriss\n- Zählerschrank\n- Zähler mit Zählernummer\n- möglicher Standort Wechselrichter/ Batteriespeicher\n- Dach\n- mögliche Verschattungen\n- Sonstiges\n',
                enabled: true
              },
              sectionId: '7k6wxtztrq9',
              type: 'STEP',
              entityRefId: 'i5qbpkhti1i',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              ecp: {
                enabled: false
              },
              userIds: [],
              name: 'Dokumente/ Fotos aus Vor-Ort-Termin über verknüpfte Klickstrecke hochladen.',
              id: 'i5qbpkhti1i',
              definitionId: 'ZmyKvhEM',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'ZmyKvhEM'
                }
              ],
              startedTime: '2025-04-07T07:20:04.826Z',
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              sectionId: '7k6wxtztrq9',
              type: 'STEP',
              entityRefId: 'wvie93r4z6y',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              userIds: [],
              name: 'Opportunity und alle relevanten Entitäten über das Teilen Symbol (oben rechts) mit dem Partner teilen.',
              id: 'wvie93r4z6y',
              definitionId: 'RvhUavum',
              status: 'UNASSIGNED',
              manuallyCreated: false
            }
          ],
          assignedTo: [],
          definitionId: 'j7eJh3wY',
          status: 'IN_PROGRESS',
          enabled: true
        },
        {
          name: 'Prüfungsphase Partner',
          id: '0wgz78m617a',
          type: 'SECTION',
          steps: [
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'ZmyKvhEM'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'RvhUavum'
                }
              ],
              startedTime: '2025-04-07T07:20:04.826Z',
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'Hinweis: Die Terminbestätigung an Interessent:in wird automatisch versandt.',
                enabled: true
              },
              sectionId: '0wgz78m617a',
              type: 'STEP',
              entityRefId: 'fqdz6e36lff',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              userIds: [],
              name: 'Partner: optionale 2. Vor-Ort-Terminvereinbarung - Datum in Feld "2. Vor-Ort-Termin" eintragen. Falls nicht relevant, Schritt überspringen.',
              id: 'fqdz6e36lff',
              definitionId: 'c36_ZWe9',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'ZmyKvhEM'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'RvhUavum'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                }
              ],
              startedTime: '2025-04-07T07:20:04.826Z',
              journey: {
                journeyId: '020421a0-1126-11f0-bc7b-f59f0d1cc396',
                name: 'Allgemein - Uploads Partner',
                id: '7f2f19c5-1ecb-4997-8e9e-42d4a8d5245e'
              },
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'In diesem Schritt ist eine Klickstrecke integriert, in der Sie das Angebot übermitteln können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                enabled: true
              },
              sectionId: '0wgz78m617a',
              type: 'STEP',
              entityRefId: 'viktpwsceuu',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              ecp: {
                enabled: false
              },
              userIds: [],
              name: 'Partner: Erstellung Angebot - Dokument über verknüpfte Klickstrecke hochladen.',
              id: 'viktpwsceuu',
              definitionId: '7v_W2vaH',
              status: 'UNASSIGNED',
              manuallyCreated: false
            }
          ],
          assignedTo: [],
          definitionId: '-hj_-Fi3',
          status: 'OPEN',
          enabled: true
        },
        {
          name: 'Angebotsphase',
          id: '3p9ui2plyqd',
          type: 'SECTION',
          steps: [
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'ZmyKvhEM'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'RvhUavum'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '7v_W2vaH'
                }
              ],
              startedTime: '2025-04-07T07:20:04.826Z',
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              sectionId: '3p9ui2plyqd',
              type: 'STEP',
              entityRefId: '789t88yeke8',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              ecp: {
                enabled: false
              },
              userIds: [],
              name: 'Handwerker-Angebot überprüfen und auf Basis des Angebots eine Bestellung unter Gruppe "Bestellungen und Angebote" anlegen und speichern.',
              id: '789t88yeke8',
              definitionId: 'p3Pgs00f',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'ZmyKvhEM'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'RvhUavum'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '7v_W2vaH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                }
              ],
              startedTime: '2025-04-07T07:20:04.826Z',
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              description: {
                value:
                  'Hinweis: Sobald das finale Angebot an Interessent:in versandt wurde Automatisierung ausführen, um das Datum der Übermittlung in das entsprechende Feld zu übertragen.',
                enabled: true
              },
              sectionId: '3p9ui2plyqd',
              type: 'STEP',
              entityRefId: 'eq78j1ug0bm',
              automationConfig: {
                flowId: '5de894b0-174e-49e4-9eb5-884cb032e17c'
              },
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              ecp: {
                description:
                  'Wir planen aktuell Ihre individuelle Photovoltaik-Anlage.',
                enabled: true,
                label: 'Planung der Photovoltaik-Anlage'
              },
              userIds: [],
              name: 'Email-Vorlage "PV - Finales Angebot inkl. Angebotsannahme" auswählen, erstelltes Angebot prüfen und E-Mail versenden.',
              id: 'eq78j1ug0bm',
              definitionId: 'OfHwI_qm',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'ZmyKvhEM'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'RvhUavum'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '7v_W2vaH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                }
              ],
              startedTime: '2025-04-07T07:20:04.826Z',
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              sectionId: '3p9ui2plyqd',
              type: 'STEP',
              entityRefId: 'd60g0m93xns',
              automationConfig: {
                flowId: 'b5c07ff3-b5a4-4f13-90c0-ad9004e63fb1'
              },
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              dynamicDueDate: {
                stepId: 'OfHwI_qm',
                timePeriod: 'days',
                numberOfUnits: 7,
                actionTypeCondition: 'STEP_CLOSED'
              },
              userIds: [],
              name: 'Angebotsannahme erfolgt? Wenn "Nein" Automatisierungsschritt ausführen, um Reminder zu senden. Wenn "Ja", Schritt überspringen.',
              id: 'd60g0m93xns',
              definitionId: '5h5bw2yO',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'ZmyKvhEM'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'RvhUavum'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '7v_W2vaH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '5h5bw2yO'
                }
              ],
              startedTime: '2025-04-07T07:20:04.826Z',
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              sectionId: '3p9ui2plyqd',
              type: 'STEP',
              entityRefId: 'huhcr2em6eb',
              automationConfig: {
                flowId: '497dbc84-9c70-42e6-8aba-e85103ca9ba2'
              },
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              ecp: {
                description:
                  'Sind Sie mit dem unterbreiteten Angebot zufrieden?',
                enabled: true,
                label: 'Angebotsphase'
              },
              dynamicDueDate: {
                stepId: '5h5bw2yO',
                timePeriod: 'days',
                numberOfUnits: 7,
                actionTypeCondition: 'STEP_CLOSED'
              },
              userIds: [],
              name: 'Angebotsannahme erfolgt? Wenn "Nein", Automatisierungsschritt ausführen, um Interessent:in über Prozessabbruch zu informieren - Prozess abbrechen und Abbruchgrund nennen. Wenn "Ja", Schritt überspringen.',
              id: 'huhcr2em6eb',
              definitionId: 'HMTLIkea',
              status: 'UNASSIGNED',
              manuallyCreated: false
            }
          ],
          assignedTo: [],
          definitionId: 'nkelpCQ7',
          status: 'OPEN',
          enabled: true
        },
        {
          name: 'Vorbereitung Bereitstellung',
          id: 'mwd65w1sszc',
          type: 'SECTION',
          steps: [
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'ZmyKvhEM'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'RvhUavum'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '7v_W2vaH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '5h5bw2yO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'HMTLIkea'
                }
              ],
              startedTime: '2025-04-07T07:20:04.826Z',
              journey: {
                journeyId: '0240b570-1126-11f0-8e95-4d06e2df98e6',
                name: 'Allgemein - Uploads Vertrieb',
                id: 'f61cd947-c717-4aaa-a424-6f0a2e91e322'
              },
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die 1. Anzahlungsrechnung übermitteln können. Klicken Sie dafür auf "Allgemein - Uploads Vertrieb".',
                enabled: true
              },
              sectionId: 'mwd65w1sszc',
              type: 'STEP',
              entityRefId: 'cvpeth4phx0',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              userIds: [],
              name: 'ERP: 1. Anzahlungsrechnung erstellen: Rechnungsversand an Kund:in (1. Rechnung - Anzahlung) - Anzahlungsrechnung über verknüpfte Klickstrecke hochladen.',
              id: 'cvpeth4phx0',
              definitionId: 'dd7i4fmj',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'ZmyKvhEM'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'RvhUavum'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '7v_W2vaH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '5h5bw2yO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'HMTLIkea'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dd7i4fmj'
                }
              ],
              startedTime: '2025-04-07T07:20:04.826Z',
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              description: {
                value:
                  'Hinweis: Mit der Ausführung der Automatisierung wird das Datum der Beauftragung des Partners in das entsprechende Feld übertragen. Die Beauftragung des Partners ist in den weiteren informationen im nächsten Schritt vermerkt.',
                enabled: true
              },
              sectionId: 'mwd65w1sszc',
              type: 'STEP',
              entityRefId: 'lrqnd0ntkm6',
              automationConfig: {
                flowId: 'f7635782-6eb9-424a-8a5b-2c73623adb27'
              },
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              dynamicDueDate: {
                stepId: 'dd7i4fmj',
                timePeriod: 'days',
                numberOfUnits: 7,
                actionTypeCondition: 'STEP_CLOSED'
              },
              userIds: [],
              name: 'Wiedervorlage: Zahlung eingegangen? Wenn "Ja", Automatisierungsschritt ausführen - Beauftragung des Partners über nachfolgende Aufgabe. Wenn "Nein", Kontaktaufnahme mit Kund:in und neue Frist auf T+7 setzen.',
              id: 'lrqnd0ntkm6',
              definitionId: 'G8Y9cTif',
              status: 'UNASSIGNED',
              manuallyCreated: false
            }
          ],
          assignedTo: [],
          definitionId: '65Dt7ZS9',
          status: 'OPEN',
          enabled: true
        },
        {
          name: 'Installation inkl. Fertigstellung Partner',
          id: 'zo2dw2kgd00',
          type: 'SECTION',
          steps: [
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'ZmyKvhEM'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'RvhUavum'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '7v_W2vaH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '5h5bw2yO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'HMTLIkea'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dd7i4fmj'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'G8Y9cTif'
                }
              ],
              startedTime: '2025-04-07T07:20:04.826Z',
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'Finale Beauftragung für Installation der Photovoltaik-Anlage: \nKund:in hat das Angebot angenommen. Für die Antragstellung beim Netzbetreiber, sowie die weitere interne Organisation bitte die Widerrufsfrist beachten (siehe Feld Ende Widerrufsfrist)!\n',
                enabled: true
              },
              sectionId: 'zo2dw2kgd00',
              type: 'STEP',
              entityRefId: 'bqa09757ro9',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              userIds: [],
              name: 'Partner: Antragstellung beim Netzbetreiber',
              id: 'bqa09757ro9',
              definitionId: 'bTVIdKd5',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'ZmyKvhEM'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'RvhUavum'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '7v_W2vaH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '5h5bw2yO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'HMTLIkea'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dd7i4fmj'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'G8Y9cTif'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'bTVIdKd5'
                }
              ],
              startedTime: '2025-04-07T07:20:04.826Z',
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              sectionId: 'zo2dw2kgd00',
              type: 'STEP',
              entityRefId: 'blan8da0ewi',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              userIds: [],
              name: 'Partner: Terminvereinbarung und Baubeginn (nach Widerrufsfrist) - Datum Baubeginn in Feld "Baubeginn" eintragen.',
              id: 'blan8da0ewi',
              definitionId: 'g3eVTm5t',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'ZmyKvhEM'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'RvhUavum'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '7v_W2vaH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '5h5bw2yO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'HMTLIkea'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dd7i4fmj'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'G8Y9cTif'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'bTVIdKd5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'g3eVTm5t'
                }
              ],
              startedTime: '2025-04-07T07:20:04.826Z',
              journey: {
                journeyId: '020421a0-1126-11f0-bc7b-f59f0d1cc396',
                name: 'Allgemein - Uploads Partner',
                id: '7f2f19c5-1ecb-4997-8e9e-42d4a8d5245e'
              },
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'In diesem Schritt ist eine Klickstrecke integriert, in der Sie das Abnahmeprotokoll der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                enabled: true
              },
              sectionId: 'zo2dw2kgd00',
              type: 'STEP',
              entityRefId: '7sh784raar7',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              userIds: [],
              name: 'Partner: Baumaßnahmen wurden fertiggestellt und abgenommen - Datum der Fertigstellung in Feld "Fertigstellung" eintragen - Abnahmeprotokoll über verknüpfte Klickstrecke hochladen.',
              id: '7sh784raar7',
              definitionId: 'An4yz9pM',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'ZmyKvhEM'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'RvhUavum'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '7v_W2vaH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '5h5bw2yO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'HMTLIkea'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dd7i4fmj'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'G8Y9cTif'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'bTVIdKd5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'g3eVTm5t'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'An4yz9pM'
                }
              ],
              startedTime: '2025-04-07T07:20:04.826Z',
              journey: {
                journeyId: '020421a0-1126-11f0-bc7b-f59f0d1cc396',
                name: 'Allgemein - Uploads Partner',
                id: '7f2f19c5-1ecb-4997-8e9e-42d4a8d5245e'
              },
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Dokumentation der Errichtung und der Inbetriebnahme der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                enabled: true
              },
              sectionId: 'zo2dw2kgd00',
              type: 'STEP',
              entityRefId: '9jjxqb757di',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              ecp: {
                enabled: true,
                label: 'Installation inkl. Fertigstellung'
              },
              userIds: [],
              name: 'Partner: Dokumentation der Errichtung und der Inbetriebnahme - Dokumente über verknüpfte Klickstrecke hochladen.',
              id: '9jjxqb757di',
              definitionId: 'oYLqfdHr',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'ZmyKvhEM'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'RvhUavum'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '7v_W2vaH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '5h5bw2yO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'HMTLIkea'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dd7i4fmj'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'G8Y9cTif'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'bTVIdKd5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'g3eVTm5t'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'An4yz9pM'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'oYLqfdHr'
                }
              ],
              startedTime: '2025-04-07T07:20:04.826Z',
              journey: {
                journeyId: '020421a0-1126-11f0-bc7b-f59f0d1cc396',
                name: 'Allgemein - Uploads Partner',
                id: '7f2f19c5-1ecb-4997-8e9e-42d4a8d5245e'
              },
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Schlussrechnung der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                enabled: true
              },
              sectionId: 'zo2dw2kgd00',
              type: 'STEP',
              entityRefId: 'k2stp7txgci',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              ecp: {
                enabled: false
              },
              userIds: [],
              name: 'Partner: Schlussrechnung erstellen - Schlussrechnung über verknüpfte Klickstrecke hochladen.',
              id: 'k2stp7txgci',
              definitionId: 'PnKp6bGK',
              status: 'UNASSIGNED',
              manuallyCreated: false
            }
          ],
          assignedTo: [],
          definitionId: 'OgeUHFyc',
          status: 'OPEN',
          enabled: true
        },
        {
          name: 'Abschluss',
          id: 'gjbhikukf23',
          type: 'SECTION',
          steps: [
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'ZmyKvhEM'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'RvhUavum'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '7v_W2vaH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '5h5bw2yO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'HMTLIkea'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dd7i4fmj'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'G8Y9cTif'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'bTVIdKd5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'g3eVTm5t'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'An4yz9pM'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'oYLqfdHr'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'PnKp6bGK'
                }
              ],
              startedTime: '2025-04-07T07:20:04.826Z',
              journey: {
                journeyId: '0240b570-1126-11f0-8e95-4d06e2df98e6',
                name: 'Allgemein - Uploads Vertrieb',
                id: 'f61cd947-c717-4aaa-a424-6f0a2e91e322'
              },
              created: '2025-04-07T07:20:04.826Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Schlussrechnung der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Vertrieb".',
                enabled: true
              },
              sectionId: 'gjbhikukf23',
              type: 'STEP',
              entityRefId: 'bat3ao1pgkn',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:20:04.826Z',
              ecp: {
                enabled: true,
                label: 'Abschluss'
              },
              userIds: [],
              name: 'ERP: Schlussrechnung an Kund:in senden - Schlussrechnung über verknüpfte Klickstrecke hochladen.',
              id: 'bat3ao1pgkn',
              definitionId: '76QWWDEa',
              status: 'UNASSIGNED',
              manuallyCreated: false
            }
          ],
          assignedTo: [],
          definitionId: '8vvcDG0J',
          status: 'OPEN',
          enabled: true
        }
      ],
      configuredClosingReasonSnapshot: [
        {
          title: 'Dach zu alt',
          id: 'aR7zJFjtI6Q0ZH_EXGtXc'
        },
        {
          title: 'Wirtschaftlichkeit',
          id: '4vDdM4Ta5TIiK2ZLQFv2M'
        },
        {
          title: 'Entscheidung für Mitbewerber',
          id: 'uUW4-bIsq5Ozm3xcmIRC8'
        },
        {
          title: 'Zeitlich nicht passend',
          id: 'ZdbD_S25HvYBZfOSX4Z1e'
        },
        {
          title: 'Keine Angabe von Gründen',
          id: 'nH_sgr1zfOtV13maXhScO'
        },
        {
          title: 'Keine Rückmeldung vom Kunden',
          id: '08xZ-Ex6VxT6fD_tZO-5E'
        },
        {
          title: 'Kosten zu hoch',
          id: 'eq8g6NXYOmqkWdh2EvieE'
        },
        {
          title: 'Zu lange Wartezeit',
          id: 'lm9Rp2kd8i94PfJpnQi7-'
        }
      ],
      contexts: [
        {
          schema: 'contact',
          title: 'Max Spark',
          id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc'
        },
        {
          schema: 'opportunity',
          title: 'OP-100 - Photovoltaik-Anlage Teil 1 (Leadgenerierung)',
          id: '5623d4b1-62d1-43ce-8118-44fc453c511c'
        }
      ],
      orgId: '16246022',
      definitionId: 'wfMXhDSGaI',
      id: '7il6fm2842x'
    }
  ],
  journey_actions: [
    {
      journey_id: '66877380-0662-11f0-a9ca-4f3dc91aee12',
      action_label: {
        en: 'Move or Terminate Contract',
        de: 'Move or Terminate Contract'
      },
      slug: 'contract'
    },
    {
      journey_id: '62144be0-05a7-11f0-9864-af17fa9de986',
      action_label: {
        en: 'IBAN Change',
        de: 'IBAN Change'
      },
      slug: 'contract'
    },
    {
      journey_id: '597b10d0-25d3-11f0-a06f-fd52871531fc',
      action_label: {
        en: 'General Request',
        de: 'Allgemeine Anfrage'
      },
      slug: 'contract',
      rules: []
    }
  ]
}
